"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_NETWORK = void 0;
exports.SOCIAL_NETWORK = {
    FACEBOOK: 'FACEBOOK',
    TWITTER: 'TWITTER',
    INSTAGRAM: 'INSTAGRAM',
    LINKED_IN: 'LINKED_IN',
    PINTEREST: 'PINTEREST',
    TIKTOK: 'TIKTOK',
    YOUTUBE: 'YOUTUBE',
    THREADS: 'THREADS'
};
//# sourceMappingURL=socialNetwork.js.map